import fp from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop, isEqual } from 'lodash';
import DatePillModal from './datepillmodal/DatePillModal';
import ListPillModal from './listpillmodal/ListPillModal';
import StringPillModal from './stringpillmodal/StringPillModal';
import NumberPillModal from './numberpillmodal/NumberPillModal';
import filterDefinitionPropType from '../../../filterDefinitionPropType';
import defaultStyles from './PillModal.module.scss';

class PillModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changesMade: false,
            value: props.filter.value,
            isBlank: false,
            form: {},
            // eslint-disable-next-line react/no-unused-state
            initialForm: {},
            isValid: true
        };
        this.modalChild = React.createRef();
        this.wipeFilter = this.wipeFilter.bind(this);
        this.setUpState = this.setUpState.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.renderChild = this.renderChild.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleUpdates = this.handleUpdates.bind(this);
        this.setForm = this.setForm.bind(this);
        this.calculateValue = this.calculateValue.bind(this);
        this.calculateValueIsBlank = this.calculateValueIsBlank.bind(this);
        this.calculateValueIsValid = this.calculateValueIsValid.bind(this);
        this.onKeyPressed = this.onKeyPressed.bind(this);
        this.setPillFocus = this.setPillFocus.bind(this);
        this.renderAllButton = this.renderAllButton.bind(this);
        this.pillModal = React.createRef();
    }

    componentDidMount() {
        this.pillModal.current.focus();
    }

    handleChange(event) {
        const { target } = event;

        let value;
        switch (target.type) {
            case 'checkbox':
                value = target.checked;
                break;
            case 'number':
                value = target.value === '' ? '' : parseFloat(target.value);
                break;
            default:
                ({ value } = target);
        }

        const valuename = target.getAttribute('valuename');

        // eslint-disable-next-line react/no-access-state-in-setstate
        const newForm = { ...this.state.form, [valuename]: value };
        const newValue = this.calculateValue(newForm);
        const blankValue = this.calculateValueIsBlank(newForm);
        const isValid = this.calculateValueIsValid(newForm);

        this.setState({
            form: newForm,
            value: newValue,
            changesMade: !isEqual(newValue, this.props.filter.value),
            isBlank: blankValue,
            isValid
        });
    }

    handleUpdate(key, value) {
        this.setState((prevState) => {
            const newForm = { ...prevState.form, [key]: value, today: false };
            const newValue = this.calculateValue(newForm);
            const blankValue = this.calculateValueIsBlank(newForm);
            const isValid = this.calculateValueIsValid(newForm);

            return {
                form: newForm,
                value: newValue,
                changesMade: !isEqual(newValue, this.props.filter.value),
                isBlank: blankValue,
                isValid
            };
        });
    }

    handleUpdates(updates) {
        this.setState((prevState) => {
            const newForm = { ...prevState.form, ...updates };
            const newValue = this.calculateValue(newForm);
            const blankValue = this.calculateValueIsBlank(newForm);
            const isValid = this.calculateValueIsValid(newForm);

            return {
                form: newForm,
                value: newValue,
                changesMade: !isEqual(newValue, this.props.filter.value),
                isBlank: blankValue,
                isValid
            };
        });
    }

    onKeyPressed(e) {
        if (e.keyCode === 27) { // Escape
            this.props.closeFilter();
        }
        if (this.state.changesMade && e.keyCode === 13) { // Enter
            this.props.updateFilter(
                this.props.filter.title,
                this.calculateValue(this.state.form)
            );
        } else if (e.keyCode === 13) {
            this.props.closeFilter();
        }
    }

    setPillFocus() {
        this.pillModal.current.focus();
    }

    setUpState(value, form, isBlank, isValid = true, changesMade = false) {
        this.setState({
            value,
            form,
            isBlank,
            changesMade,
            isValid,
            // eslint-disable-next-line react/no-unused-state
            initiallyBlank: isBlank,
            // eslint-disable-next-line react/no-unused-state
            initialForm: form
        });
    }

    setForm(newForm) {
        const newValue = this.calculateValue(newForm);
        const blankValue = this.calculateValueIsBlank(newForm);
        const isValid = this.calculateValueIsValid(newForm);

        this.setState({
            form: newForm,
            value: newValue,
            changesMade: !isEqual(newValue, this.props.filter.value),
            isBlank: blankValue,
            isValid
        });
        this.setPillFocus();
    }

    calculateValue(formState) {
        return this.modalChild.current.calculateValue(formState);
    }

    calculateValueIsBlank(formState) {
        return this.modalChild.current.calculateValueIsBlank(formState);
    }

    calculateValueIsValid(formState) {
        if (this.modalChild.current.calculateValueIsValid) {
            return this.modalChild.current.calculateValueIsValid(formState);
        }

        return true;
    }

    wipeFilter() {
        const { value, form } = this.modalChild.current.getEmptyValues();
        this.setState({
            value,
            form,
            isBlank: true,
            changesMade: !isEqual(value, this.props.filter.value)
        });
    }

    resetFilter() {
        this.setState((state) => ({
            changesMade: false,
            value: this.props.filter.value,
            isBlank: state.initiallyBlank,
            form: state.initialForm
        }));
    }

    renderChild(type) {
        switch (type) {
            case 'String':
                return (
                    <StringPillModal
                        filter={ this.props.filter }
                        value={ this.state.value }
                        ref={ this.modalChild }
                        handleChange={ this.handleChange }
                        setUpState={ this.setUpState }
                        resetFilter={ this.resetFilter }
                    />
                );
            case 'Number':
                return (
                    <NumberPillModal
                        filter={ this.props.filter }
                        value={ this.state.value }
                        ref={ this.modalChild }
                        handleChange={ this.handleChange }
                        handleUpdate={ this.handleUpdate }
                        setUpState={ this.setUpState }
                        resetFilter={ this.resetFilter }
                    />
                );
            case 'Date':
                return (
                    <DatePillModal
                        filter={ this.props.filter }
                        value={ this.state.value }
                        ref={ this.modalChild }
                        handleUpdate={ this.handleUpdate }
                        handleUpdates={ this.handleUpdates }
                        setUpState={ this.setUpState }
                        resetFilter={ this.resetFilter }
                        filterDefinition={ this.props.filterDefinition }
                        setPillFocus={ this.setPillFocus }
                    />
                );
            case 'List':
                return (
                    <ListPillModal
                        isAddFilter={ this.props.isAddFilter }
                        filter={ this.props.filter }
                        value={ this.state.value }
                        ref={ this.modalChild }
                        handleUpdate={ this.handleUpdate }
                        setForm={ this.setForm }
                        setUpState={ this.setUpState }
                        resetFilter={ this.resetFilter }
                        getAvailableListValues={ this.props.getAvailableListValues }
                        currentFilters={ this.props.currentFilters }
                        handleAdd={ this.props.handleAdd }
                        filterDefinition={ this.props.filterDefinition }
                    />
                );
            default:
                return null;
        }
    }

    renderAllButton() {
        if (fp.get('props.filterDefinition.hideAllButton')(this)) { return null; }

        return this.state.isBlank ? (
            <button type="button" className={ this.props.styles.all }>{ this.props.filterDefinition
                    && this.props.filterDefinition.radio ? 'None' : 'All' }
            </button>
        ) : !this.props.isAddFilter && (
            <button
                type="button"
                onClick={ this.wipeFilter }
                className={ this.props.styles['select-all'] }
            >
                {
                    (this.props.filterDefinition && this.props.filterDefinition.radio && 'Select None')
                        || 'Select All'
                }
            </button>
        );
    }

    render() {
        const { styles } = this.props;
        return (
            <div
                role="button"
                className={ classNames({
                    [styles['pill-modal']]: true,
                    [styles.shadow]: true,
                    [`pill-modal-${this.props.filter.type}`]: true,
                    [styles['push-right']]: this.props.pushRight,
                    wide: fp.getOr(false, 'props.filterDefinition.wide')(this)
                }) }
                onDoubleClick={ (e) => e.stopPropagation() }
                onKeyUp={ this.onKeyPressed }
                tabIndex="0"
                ref={ this.pillModal }
            >
                { this.props.filterError && (
                    <div className={ styles['pill-modal-error'] }>
                        { this.props.filterError.message }
                    </div>
                ) }
                <div className="pill-modal-header">
                    <span className={ styles['pill-modal-title'] }>{ this.props.filter.title }</span>
                    { this.renderAllButton() }

                </div>
                <div className="pill-modal-body">
                    { this.renderChild(this.props.filter.type) }
                </div>

                <div className={ styles['pill-modal-footer'] }>
                    { this.state.changesMade ? (
                        <div>
                            <button
                                type="button"
                                onClick={ this.resetFilter }
                                className={ styles['pill-modal-cancel'] }
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                disabled={ !this.state.isValid }
                                onClick={ () => {
                                    this.props.updateFilter(
                                        this.props.filter.title,
                                        this.calculateValue(this.state.form)
                                    );
                                } }
                                className={ styles['pill-modal-apply'] }
                            >
                                Apply
                            </button>
                        </div>
                    ) : (
                        <button
                            type="submit"
                            onClick={ () => { this.props.closeFilter(); } }
                            className={ styles['pill-modal-close'] }
                        >
                            Close
                        </button>
                    ) }
                </div>
            </div>
        );
    }
}

PillModal.propTypes = {
    isAddFilter: PropTypes.bool,
    closeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    filter: PropTypes.shape({
        type: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
            PropTypes.number,
            PropTypes.instanceOf(Date),
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]))
        ]).isRequired,
    }),
    filterError: PropTypes.shape({
        message: PropTypes.string
    }),
    getAvailableListValues: PropTypes.func,
    currentFilters: PropTypes.arrayOf(PropTypes.shape({})),
    handleAdd: PropTypes.func,
    pushRight: PropTypes.bool,
    filterDefinition: filterDefinitionPropType,
    styles: PropTypes.objectOf(PropTypes.string)
};

PillModal.defaultProps = {
    isAddFilter: false,
    filter: {},
    filterError: null,
    getAvailableListValues: noop,
    currentFilters: null,
    handleAdd: null,
    pushRight: false,
    filterDefinition: null,
    styles: defaultStyles
};

export default PillModal;
